var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHousePlanAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4453 11.7031C9.1671 11.8886 9 12.2008 9 12.5352V15C9 15.5523 9.44772 16 10 16H14C14.5523 16 15 15.5523 15 15V12.5352C15 12.2008 14.8329 11.8886 14.5547 11.7031L12.5547 10.3698C12.2188 10.1459 11.7812 10.1459 11.4453 10.3698L9.4453 11.7031Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7405 4.25C22.6129 2.57189 21.2108 1.25 19.5 1.25C17.7892 1.25 16.3871 2.57189 16.2595 4.25H7.74053C7.61287 2.57189 6.21081 1.25 4.5 1.25C2.78919 1.25 1.38713 2.57189 1.25947 4.25H1.25V19C1.25 20.5188 2.48122 21.75 4 21.75H20C21.5188 21.75 22.75 20.5188 22.75 19V4.25H22.7405ZM7.75 5.75H16.25V15.5C16.25 15.9142 16.5858 16.25 17 16.25C17.4142 16.25 17.75 15.9142 17.75 15.5C17.75 14.5335 18.5335 13.75 19.5 13.75C20.4665 13.75 21.25 14.5335 21.25 15.5V19C21.25 19.6904 20.6904 20.25 20 20.25H4C3.30964 20.25 2.75 19.6904 2.75 19V15.5C2.75 14.5335 3.5335 13.75 4.5 13.75C5.4665 13.75 6.25 14.5335 6.25 15.5C6.25 15.9142 6.58579 16.25 7 16.25C7.41421 16.25 7.75 15.9142 7.75 15.5V5.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousePlanAlt1);
export default __webpack_public_path__ + "static/media/house-plan-alt-1.600e729923d8a694b34bbd4cfd6e72e2.svg";
export { ForwardRef as ReactComponent };